import { Component, OnInit } from '@angular/core';
import { ViewState } from 'src/common';

@Component({
  selector: 'request-details',
  templateUrl: 'request-details.component.html'
})

export class RequestDetailsComponent implements OnInit {

  viewState = ViewState;

  constructor() { }

  ngOnInit() { }
}
